import "../../dashboard/DashboardLayout.css"
import {useNavigate} from "react-router-dom";
import './KpiCard.css'
import {KpiInfo, KpiWithSchedulerInfo} from "../../../types/types";
import {
    Switch,
    useMantineTheme,
    Loader,
    Menu,
    Badge, Blockquote, Popover, createStyles
} from "@mantine/core";
import {useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleInfo, faCirclePlus} from "@fortawesome/free-solid-svg-icons";
import {ConfirmationPopUp} from "../../popup/confirmationPopUp";


export type KpiCardProps = {
    info: KpiWithSchedulerInfo
    authContext: any
    DeleteKPI: any
    isSelectable: boolean
    onKpiSelect: (name: string) => void
    onStatusChange: (status: boolean, kpiInfo: KpiInfo) => Promise<any>
}


const capitalize = (str: string, lower = false) =>
    (lower ? str.toLowerCase() : str).replace(/(?:^|\s|["'([{])+\S/g, match => match.toUpperCase());

function makeTitle(title: string) {
    return capitalize(title.replace("_", " "));
}

function isActiveStatus(kpiInfo: KpiInfo) {
    return kpiInfo.activeStatus === 'active'
}

function getOrDefault(value: any, defaultValue: string) {
    return value ? value : defaultValue;
}

const useStyles = createStyles(() => ({
    pointerElement: {
        cursor: 'pointer',
    },
}));


export function KpiCard(props: KpiCardProps) {


    const [loading, setLoading] = useState(false);

    const [modalOpened, setModalOpened] = useState(false);

    const [openDeleteConfirmationModal, setOpenDeleteConfirmationModal] = useState(false);
    const [openRunConfirmationModal, setOpenRunConfirmationModal] = useState(false);
    const [, setCloneKpi] = useState(false);

    let theme = useMantineTheme();

    let navigate = useNavigate();

    const {classes} = useStyles();

    const kpiInfo = props.info.kpiInfo;
    const schedulerInfo = props.info.schedulerInfo;

    let footerColor = 'teal';
    if (!isActiveStatus(kpiInfo)) {
        footerColor = "gray"
    }
    if (schedulerInfo?.extendedAttributes?.status === 'FAILURE') {
        footerColor = "red";
    }

    async function onStatusChange(target: any) {
        setLoading(true)
        try {
            await props.onStatusChange(target.checked, kpiInfo);
        } catch (er) {
            console.log(er)
            navigate("/error")
        } finally {
            setLoading(false);
        }

    }

    async function RunKPI(kpiId: string) {
        // const authContext = props.authContext;
        console.log("run ", kpiId);
        // const url = EnvironmentRegistry.getUrlFromContext(authContext);
        // axios.get(`${url}/v1/kpi/info/${kpiId}`, {
        //     headers: EnvironmentRegistry.makeAuthHeadersFromContext(authContext)
        // })
    }

    function getAuthor(info: KpiInfo) {
        return info.createdBy ? info.createdBy : "Unknown User";
    }

    function getKpiClassNames(props: KpiCardProps) {
        let classNames = "kpi-card ";
        if (props.isSelectable) {
            classNames += " pointer ";
            classNames += props.info.isSelected ? " selected " : "";
        }
        return classNames;
    }

    return (
        <div className={getKpiClassNames(props)} onClick={() => props.onKpiSelect(kpiInfo.name)}>
            <div className={"kpi-card-header"}>
                <div className={""}>
                    <p className={"kpi-card-title"}>{makeTitle(kpiInfo.name)}</p>
                </div>
                <div className={"zoom pointer"}>
                    <Menu>
                        <Menu.Label>Settings</Menu.Label>
                        <Menu.Item component="a" onClick={() => navigate("/kpi/setup?id=" + kpiInfo.id)}>
                            Edit KPI
                        </Menu.Item>
                        <Menu.Item component="a" onClick={() => navigate("/kpi/setup?prefillId=" + kpiInfo.id)}>
                            Copy from KPI
                        </Menu.Item>
                        <Menu.Item component="a" onClick={() => setOpenRunConfirmationModal(true)}>
                            Run KPI
                        </Menu.Item>
                        <Menu.Item component="a" onClick={() => setOpenDeleteConfirmationModal(true)}>
                            Delete KPI
                        </Menu.Item>
                        <Menu.Item component="a" onClick={() => setCloneKpi(true)}>
                            Clone to another LOB
                        </Menu.Item>
                    </Menu>
                </div>
            </div>
            <div className={"kpi-card-content"}>
                <div className={"kpi-card-content-section centered"}>
                    {loading ? <Loader/> : <div>
                        <Blockquote cite={"– Created By " + getAuthor(kpiInfo) + ""} icon={null}>
                            <p className={"kpi-card-content-text"}>{kpiInfo.description}</p>
                        </Blockquote>
                    </div>}

                </div>

            </div>

            <div className={"kpi-card-footer"} style={{backgroundColor: theme.colors[footerColor][5]}}>
                <Switch className={classes.pointerElement} color="violet" checked={isActiveStatus(kpiInfo)}
                        onLabel="Active"
                        offLabel="Inactive"
                        onChange={(event) => onStatusChange(event.currentTarget)}/>

                <Popover
                    opened={modalOpened}
                    onClose={() => setModalOpened(false)}
                    target={<FontAwesomeIcon onClick={() => setModalOpened(true)}
                                             onMouseLeave={() => setModalOpened(false)}
                                             onMouseEnter={() => setModalOpened(true)}
                                             className={"pointer"} color={"white"}
                                             size="2x"
                                             icon={faCircleInfo}/>}
                    position="top"
                    width={300}
                    style={{"padding": "0"}}
                >
                    <table className="styled-table">
                        <tbody>
                        <tr>

                            <td>Executed At</td>
                            <td>{getOrDefault(schedulerInfo?.lastModifiedTime, "N/A")}</td>
                        </tr>
                        <tr className="active-row">
                            <td>Status</td>
                            <td><Badge
                                color={footerColor}>{getOrDefault(schedulerInfo?.extendedAttributes?.status, "N/A")}</Badge>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </Popover>

            </div>
            <ConfirmationPopUp message="Are you sure you want to delete this KPI?"
                               openConfirmModal={openDeleteConfirmationModal}
                               setOpenConfirmModal={setOpenDeleteConfirmationModal}
                               successMethod={() => kpiInfo.id && props.DeleteKPI(kpiInfo.id)}/>
            <ConfirmationPopUp message="Are you sure you want to run this KPI?"
                               openConfirmModal={openRunConfirmationModal}
                               setOpenConfirmModal={setOpenRunConfirmationModal}
                               successMethod={() => kpiInfo.id && RunKPI(kpiInfo.id)}/>
        </div>
    );
}

export function AddKpiCard() {

    const theme = useMantineTheme();

    const navigate = useNavigate();
    return (
        <div className={"kpi-card centered "}>
            <div>
                <h2 className={"kpi-add-card-title"}>Create new KPI</h2>
            </div>
            <FontAwesomeIcon className={"pointer add-kpi-icon"} onClick={() => navigate("kpi/setup")}
                             style={{color: theme.colors.teal[5]}} icon={faCirclePlus}/>
        </div>
    );
}

